import request from '@/utils/request'

const prefix = '/django_rest'

export default {
  getResourceLibraryInfo (params) {
    return request.get(`${prefix}/resource-library/`, { params })
  },
  uploadResourceToLibrary (resourceInfo) {
    return request.post(`${prefix}/resource-library/`, resourceInfo)
  },
  getVideoNavigationConfig (params) {
    return request.get(`${prefix}/video-navigation/page-setting/`, { params })
  }
}
